"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerContextTypeEnum = exports.WorkflowOriginEnum = exports.WorkflowTypeEnum = exports.WorkflowCreationSourceEnum = void 0;
const channel_1 = require("./channel");
var WorkflowCreationSourceEnum;
(function (WorkflowCreationSourceEnum) {
    WorkflowCreationSourceEnum["TEMPLATE_STORE"] = "template_store";
    WorkflowCreationSourceEnum["EDITOR"] = "editor";
    WorkflowCreationSourceEnum["NOTIFICATION_DIRECTORY"] = "notification_directory";
    WorkflowCreationSourceEnum["ONBOARDING_DIGEST_DEMO"] = "onboarding_digest_demo";
    WorkflowCreationSourceEnum["ONBOARDING_IN_APP"] = "onboarding_in_app";
    WorkflowCreationSourceEnum["EMPTY_STATE"] = "empty_state";
    WorkflowCreationSourceEnum["DROPDOWN"] = "dropdown";
    WorkflowCreationSourceEnum["ONBOARDING_GET_STARTED"] = "onboarding_get_started";
    WorkflowCreationSourceEnum["BRIDGE"] = "bridge";
    WorkflowCreationSourceEnum["DASHBOARD"] = "dashboard";
})(WorkflowCreationSourceEnum || (exports.WorkflowCreationSourceEnum = WorkflowCreationSourceEnum = {}));
/**
 * Enum to define the type of the workflow.
 *
 * One of its responsibilities is to help the API determine whether "changes" need to be created during the upsert process.
 */
var WorkflowTypeEnum;
(function (WorkflowTypeEnum) {
    WorkflowTypeEnum["REGULAR"] = "REGULAR";
    WorkflowTypeEnum["ECHO"] = "ECHO";
    WorkflowTypeEnum["BRIDGE"] = "BRIDGE";
})(WorkflowTypeEnum || (exports.WorkflowTypeEnum = WorkflowTypeEnum = {}));
/**
 * Enum to define the origin of the workflow.
 *
 * The `WorkflowOriginEnum` is used to specify the source of the workflow,
 * which helps determine which endpoint to call during the Preview & Execution phase.
 * * - 'novu-cloud' indicates that the workflow originates from Novu's platform, so the Novu-hosted endpoint is used.
 * * - 'external' indicates that the workflow originates from an external source, requiring a call to a customer-hosted Bridge endpoint.
 */
var WorkflowOriginEnum;
(function (WorkflowOriginEnum) {
    WorkflowOriginEnum["NOVU_CLOUD"] = "novu-cloud";
    WorkflowOriginEnum["NOVU_CLOUD_V1"] = "novu-cloud-v1";
    WorkflowOriginEnum["EXTERNAL"] = "external";
})(WorkflowOriginEnum || (exports.WorkflowOriginEnum = WorkflowOriginEnum = {}));
var TriggerContextTypeEnum;
(function (TriggerContextTypeEnum) {
    TriggerContextTypeEnum["TENANT"] = "tenant";
    TriggerContextTypeEnum["ACTOR"] = "actor";
})(TriggerContextTypeEnum || (exports.TriggerContextTypeEnum = TriggerContextTypeEnum = {}));
//# sourceMappingURL=notification-templates.js.map